
import React, { useEffect } from "react";
import { Icon, Spinner, SpinnerSize } from '@fluentui/react';
import PeoplePicker from "../formFields/PeoplePicker";

const Person = ({ user, onChange, onValidation, isRequired, disabled, isreadonly, userType, limited, errorMessage, includePowerPlatformEnvironments, warningMessage, includeManagementInfo, isValidating, additionalIcon}) => {

    const users = Array.isArray(user) ? user.filter(x => x.id) : (user && user.id ? [user] : []);

    useEffect(() => {
        if (onValidation)
            onValidation(isUserValid(users))
    }, [errorMessage])
    

    const onSelectedUser = (selectedUser) => {
        onChange(selectedUser);
        if (onValidation) {
            onValidation(isUserValid(selectedUser));
        }
    };

    const isUserValid = (users) => {
        if (errorMessage)
            return false
        if (isRequired)
            return users && users.length > 0 && !users[0].isDeleted;

        return true
    };

    const warningText = !errorMessage ? (users.length > 0 ? 'User account is not active.' : 'Field cannot be empty.') : '';

    const warningIcon = (
        <div className='warning-inline warning-nolabel-peoplepicker'>
            <Icon title={warningText} iconName="Warning" />
        </div>
    );

    const warning = !isUserValid(users) && warningIcon;
    const validation = isValidating ? <div title='Validating...' className='validation-spinner-withLabel' style={{top: '30px'}}><Spinner size={SpinnerSize.medium} /></div> : null;

    return (
        <div style={{ marginBottom: '10px', position: 'relative' }}>
            <div className="item-title">{userType}</div>
            {warning}
            {validation}
            <div className='absoluteIcon warning-nolabel-peoplepicker'>
                {additionalIcon}
            </div>
            <PeoplePicker
                disabled={disabled || isreadonly}
                key="person"
                defaultUsers={users}
                onSelectedUsers={onSelectedUser}
                itemLimit={limited ? 1 : undefined}
                includeManager={limited}
                errorMessage={errorMessage}
                warningMessage={warningMessage}
                isWarning={!!warning}
                includePowerPlatformEnvironments={includePowerPlatformEnvironments}
                includeManagementInfo={includeManagementInfo}
            />
        </div>
    );
};

export default Person;




// WEBPACK FOOTER //
// ./src/components/EditSite/Person.js